import React, { useState, useEffect, useReducer, useRef } from 'react';
import VendingService from '../services/VendingService';
import ResponseParser from '../util/ResponseParser';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DataTable from './DataTable';
import DashBoard from './DashBoard';
import { Link } from 'react-router-dom';
import subDays from 'date-fns/subDays';
import Modal from './Modal';
import { useReactToPrint } from 'react-to-print';
import ModalReceipt from './ModalReceipt';
import { formatNumber } from '../util/Formater';
import { xmlReceipt, sampleHistory } from '../util/Constant';
import { FaPrint, FaAt, FaSms } from 'react-icons/fa';

function reducer(state, action) {
   switch (action.type) {
      case 'updateField':
         return { ...state, [action.payload.field]: action.payload.value };
      case 'cancel':
         return { ...state, isModalActive: false };
      case 'show':
         return {
            ...state,
            isModalActive: action.payload.isModalActive,
            transactionId: action.payload.transactionId,
            msisdn: action.payload.msisdn,
            modalTitle: action.payload.modalTitle,
            buttonLabel: action.payload.buttonLabel,
            actionSubmit: action.payload.actionSubmit,
         };
      case 'submited':
         return {
            ...state,
            isModalActive: action.payload.isModalActive,
            transactionId: action.payload.transactionId,
         };
      case 'reprint':
         return {
            ...state,
            isModalActive: action.payload.isModalActive,
            transactionId: action.payload.transactionId,
            tokenReceipt: action.payload.tokenReceipt,
            buttonLabel: action.payload.buttonLabel,
         };
      case 'loading':
         return {
            ...state,
            isLoading: !state.isLoading,
         };
      case 'sendEmail':
         return { ...state };
      default:
         break;
   }
}

export default function Sales() {
   const [startDate, setStartDate] = useState(subDays(new Date(), 7));
   const [endDate, setEndDate] = useState(new Date());
   const [salesHistory, setSalesHistory] = useState([]);
   const [totalSalesAmount, setTotalSalesAmount] = useState(0);
   const savedUser = JSON.parse(sessionStorage.getItem('user'));
   const [agentAccount, setAgentAccount] = useState({});
   const [type, setType] = useState('');
   const componentRef = useRef();

   const [state, dispatch] = useReducer(reducer, {
      isModalActive: false,
      renderContent: () => {},
      isLoading: false,
      modalTitle: '',
      buttonLabel: '',
      msisdn: '',
      email: '',
      transactionId: '',
      tokenReceipt: {},
   });

   const columns = [
      {
         columnCaption: 'Transaction #',
         columnKey: 'transactionid',
         type: 'text',
         // content: (item) => <Link to=''>{item.transactionid}</Link>,
      },
      {
         columnCaption: 'Buyer Identifier',
         columnKey: 'buyeridentifier',
      },
      {
         columnCaption: 'Amount',
         columnKey: 'amount',
      },
      {
         columnCaption: 'Status',
         columnKey: 'status',
         content: (item) => {
            if (item.status === 'SALE COMPLETED')
               return <span className='tag is-link is-light'>{item.status}</span>;
            else return <span className='tag is-danger is-light'>{item.status}</span>;
         },
      },
      {
         columnCaption: 'Product',
         columnKey: 'product',
      },
      {
         columnCaption: 'Time',
         columnKey: 'datetime',
      },
      {
         columnCaption: 'Action',
         content: (item) => {
            if (item.status === 'SALE COMPLETED')
               return (
                  <>
                     <span className='is-size-6 mr-3' onClick={() => showModal(item, 'reprint')}>
                        <FaPrint />
                     </span>
                     <span className='is-size-6 mr-3' onClick={() => showModal(item, 'send-sms')}>
                        <FaSms />
                     </span>
                     <span>
                        <FaAt onClick={() => showModal(item, 'send-email')} />
                     </span>
                  </>
               );
         },
      },
   ];

   const getSalesHistory = () => {
      let { partnerId } = savedUser;
      let requestData = { partnerId, startDate, endDate };
      dispatch({ type: 'loading' });
      // setSalesHistory(sampleHistory);
      VendingService.getSalesHistory(requestData)
         .then((res) => res.text())
         .then((data) => {
            let response = ResponseParser.parseSaleHistoryResponse(data);
            let totalAmount = response.salesHistory.reduce((sum, item) => {
               return sum + parseInt(item.amount);
            }, 0);
            setTotalSalesAmount(totalAmount);
            setSalesHistory(response.salesHistory);
            dispatch({ type: 'loading' });
         })
         .catch((error) => {
            console.log(error);
         });
   };

   function getVendingSummary() {
      let { partnerId } = savedUser;
      VendingService.getSalesSummary({ partnerId })
         .then((res) => res.text())
         .then((data) => {
            let response = ResponseParser.parseSaleSummaryResponse(data);
            setAgentAccount({
               vendorNames: response.vendorNames,
               totalSalesCount: response.totalSalesCount,
               vendorAccountBalance: response.vendorAccountBalance,
               totalSalesAmount: response.totalSalesAmount,
               refillThresholdBalance: response.refillThresholdBalance,
               favorites: response.favorites,
               products: response.products,
            });
         })
         .catch((error) => {
            console.log(error);
         });
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      getSalesHistory();
   };

   const updateField = (field, value) => {
      dispatch({ type: 'updateField', payload: { field, value } });
   };

   const showModal = (selectedItem, action) => {
      switch (action) {
         case 'send-email':
            setType('send-email');
            dispatch({
               type: 'show',
               payload: {
                  transactionId: selectedItem.transactionid,
                  modalTitle: 'Send Token Email',
                  buttonLabel: 'Send',
                  isModalActive: true,
                  renderContent: renderEmailForm,
                  actionSubmit: sendEmail,
               },
            });
            return;
         case 'send-sms':
            setType('send-sms');
            dispatch({
               type: 'show',
               payload: {
                  transactionId: selectedItem.transactionid,
                  msisdn: formatMobileNumber(selectedItem.mobilenumber),
                  modalTitle: 'Send Token By SMS',
                  buttonLabel: 'Send',
                  isModalActive: true,
                  renderContent: renderSmsForm,
                  actionSubmit: sendSms,
               },
            });
            return;
         case 'reprint':
            getTokenReceipt(selectedItem);
            break;
         default:
            break;
      }
   };

   const formatMobileNumber = (givenMsisdn) => {
      console.log(givenMsisdn);
      if (givenMsisdn.length < 10) {
         return '0' + givenMsisdn;
      } else return givenMsisdn;
   };

   const cancelModal = (e) => {
      e.preventDefault();
      dispatch({ type: 'cancel' });
   };

   const sendEmail = (e) => {
      e.preventDefault();
      let { partnerId } = savedUser;
      dispatch({ type: 'loading' });
      VendingService.sendEmailReceipt({
         partnerId,
         email: state.email,
         transactionId: state.transactionId,
      })
         .then((resp) => resp.text())
         .then((data) => {
            let response = ResponseParser.parseSendEmailResponse(data);
            dispatch({
               type: 'submited',
               payload: { isModalActive: false, transactionId: response.transactionId },
            });
            dispatch({ type: 'loading' });
         })
         .catch((error) => {
            console.log(error);
         });
   };

   const sendSms = (e) => {
      e.preventDefault();
      let { partnerId } = savedUser;
      dispatch({ type: 'loading' });
      VendingService.sendSmsReceipt({
         partnerId,
         msisdn: state.msisdn,
         transactionId: state.transactionId,
      })
         .then((resp) => resp.text())
         .then((data) => {
            let response = ResponseParser.parseSendSmsResponse(data);
            dispatch({
               type: 'submited',
               payload: { isModalActive: false, transactionId: response.transactionId },
            });
            dispatch({ type: 'loading' });
         })
         .catch((error) => {
            console.log(error);
         });
   };

   const renderEmailForm = () => {
      return (
         <React.Fragment>
            <form className='section'>
               <div className='field'>
                  <label htmlFor='' className='label'>
                     Transaction #
                  </label>
                  <div className='control'>
                     <input
                        className='input is-small'
                        value={state.transactionId}
                        name='transactionId'
                        onChange={(e) => updateField(e.currentTarget.name, e.currentTarget.value)}
                        disabled
                     />
                  </div>
               </div>
               <div className='field'>
                  <label htmlFor='' className='label'>
                     Email
                  </label>
                  <div className='control'>
                     <input
                        className='input is-small is-rounded'
                        type='text'
                        name='email'
                        value={state.email}
                        onChange={(e) => updateField(e.target.name, e.target.value)}
                     />
                  </div>
               </div>
            </form>
         </React.Fragment>
      );
   };

   const renderSmsForm = () => {
      return (
         <>
            <form className='section'>
               <div className='field'>
                  <label htmlFor='' className='label'>
                     Transaction #
                  </label>
                  <div className='control'>
                     <input
                        className='input is-small'
                        value={state.transactionId}
                        name='transactionId'
                        onChange={(e) => updateField(e.target.name, e.target.value)}
                        disabled
                     />
                  </div>
               </div>
               <div className='field'>
                  <label htmlFor='' className='label'>
                     Customer Phone
                  </label>
                  <div className='control'>
                     <input
                        className='input is-small is-rounded'
                        type='text'
                        name='msisdn'
                        value={state.msisdn}
                        onChange={(e) => updateField(e.target.name, e.target.value)}
                     />
                  </div>
               </div>
            </form>
         </>
      );
   };

   const renderTokenReceipt = () => {
      return (
         <>
            {/* <Receipt title={'Token Receipt'} tokenReceipt={state.tokenReceipt} /> */}
            <ModalReceipt tokenReceipt={state.tokenReceipt} />
         </>
      );
   };

   const getTokenReceipt = (selectedItem) => {
      let { partnerId } = savedUser;
      // let response = ResponseParser.parseTokenReceiptResponse(xmlReceipt);
      // console.log(response);
      // setType('reprint');
      // dispatch({
      //    type: 'reprint',
      //    payload: {
      //       isModalActive: true,
      //       transactionId: response.transactionId,
      //       tokenReceipt: response,
      //       buttonLabel: 'Print',
      //    },
      // });
      VendingService.getReceipt({
         partnerId,
         transactionId: selectedItem.transactionid,
      })
         .then((resp) => resp.text())
         .then((data) => {
            let response = ResponseParser.parseTokenReceiptResponse(data);
            console.log(response);
            setType('reprint');
            dispatch({
               type: 'reprint',
               payload: {
                  isModalActive: true,
                  transactionId: response.transactionId,
                  tokenReceipt: response,
                  buttonLabel: 'Print',
               },
            });
         })
         .catch((error) => {
            console.log(error);
         });
   };

   const handlePrint = () => {
      dispatch({ type: 'cancel' });
      printComponent();
   };

   const printComponent = useReactToPrint({
      content: () => componentRef.current,
      documentTitle: `Receipt-${state.tokenReceipt.receiptNumber}`,
      copyStyles: true,
   });

   useEffect(getSalesHistory, []);
   useEffect(getVendingSummary, []);

   return (
      <>
         <section className='section'>
            <DashBoard user={savedUser} account={agentAccount} />
            <div className='is-divider' data-content=''></div>
            <div className='columns'>
               <div className='column is-5 is-offset-1'>
                  <div className='box'>
                     <form onSubmit={handleSubmit}>
                        <div className='field is-horizontal'>
                           <div className='field-body'>
                              <div className='field'>
                                 <DatePicker
                                    className='input is-small'
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    dateFormat='dd/MM/yyyy'
                                    id='startDate'
                                    name='startDate'
                                    placeholder='From'
                                 />
                                 <span className='icon is-small is-left'>
                                    <i className='fas fa-user'></i>
                                 </span>
                              </div>
                              <div className='field'>
                                 <DatePicker
                                    className='input is-small is-success'
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    dateFormat='dd/MM/yyyy'
                                    id='endDate'
                                    name='endDate'
                                    placeholder='To'
                                    value={endDate}
                                 />
                              </div>
                              <button
                                 type='submit'
                                 className={`button is-link is-small ${
                                    state.isLoading ? 'is-loading' : ''
                                 }`}
                              >
                                 Search
                              </button>
                           </div>
                        </div>
                     </form>
                  </div>
               </div>
               <div className='column is-5'>
                  <div className='columns is-multiple'>
                     <div className='column is-6'>
                        <div className='box notification is-link is-light'>
                           <p className='heading'>Transactions</p>
                           <p className='title is-4'>{salesHistory.length}</p>
                        </div>
                     </div>
                     <div className='column is-6'>
                        <div className='box notification is-link is-light'>
                           <p className='heading'>Total Amount</p>
                           <p className='title is-4'>
                              {salesHistory.length > 0 ? formatNumber(totalSalesAmount) : 0} FRW
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div className='columns'>
               <div className='column is-10 is-offset-1'>
                  <div style={{ display: 'grid' }}>
                     <div className='table-container'>
                        {/* <p className='subtitle'>History Records</p> */}
                        <DataTable items={salesHistory} pageSize={20} columns={columns} />
                     </div>
                  </div>
               </div>
            </div>
         </section>
         {type === 'send-email' ? (
            <Modal
               modalTitle={state.modalTitle}
               isModalActive={state.isModalActive}
               actionCancel={cancelModal}
               actionSubmit={sendEmail}
               buttonLabel={state.buttonLabel}
               selectedItem={state.selectedItem}
               isLoading={state.isLoading}
            >
               {renderEmailForm()}
            </Modal>
         ) : (
            ''
         )}
         {type === 'send-sms' ? (
            <Modal
               modalTitle={state.modalTitle}
               isModalActive={state.isModalActive}
               actionCancel={cancelModal}
               actionSubmit={sendSms}
               buttonLabel={state.buttonLabel}
               selectedItem={state.selectedItem}
               isLoading={state.isLoading}
            >
               {renderSmsForm()}
            </Modal>
         ) : (
            ''
         )}
         {type === 'reprint' ? (
            <Modal
               modalTitle={state.modalTitle}
               isModalActive={state.isModalActive}
               actionCancel={cancelModal}
               actionSubmit={handlePrint}
               buttonLabel={state.buttonLabel}
               selectedItem={state.selectedItem}
               isLoading={state.isLoading}
            >
               {renderTokenReceipt()}
            </Modal>
         ) : (
            ''
         )}
         <div style={{ display: 'none' }}>
            <ModalReceipt tokenReceipt={state.tokenReceipt} ref={componentRef} />
         </div>
      </>
   );
}
